import * as React from "react";
import {Component} from "react";
import Stars from "./Stars";
import {Button, Icon} from "bloomer";
import "./style.css";

interface IRatingWindowProps {
    average: number;
    userScore: number;
    totalReviews: number;
    onBlur: any;
    onReviewSave: any;
}

interface IRatingWindowState {
    loading: boolean;
    currentScore: number;
    totalReviews: number;
}

class RatingWindow extends Component<IRatingWindowProps, IRatingWindowState> {
    public element: any = null;

    public constructor(props: IRatingWindowProps) {
        super(props);

        this.state = {
            totalReviews: props.totalReviews,
            currentScore: 0,
            loading: false
        };
    }

    public componentDidMount() {
        if (this.element) {
            this.element.focus();
        }
    }

    public async onReviewSave() {
        const currentScore = this.state.currentScore;
        if (currentScore && !this.state.loading) {
            this.setState({loading: true});
            const response = await this.props.onReviewSave(currentScore);
            if (response) {
                this.setState({
                    loading: false
                }, () => {
                    this.setState({
                        currentScore: 0
                    });
                });
            }
        }
    }

    public render() {
        const isReviewed = this.props.userScore > 0;

        return <div
            className="RatingWindowMainContainer"
            tabIndex={0}
            ref={(el: any) => {
                this.element = el;
            }}
            onBlur={(e: any) => {
                if (!e.currentTarget.contains(e.relatedTarget)) {
                    this.props.onBlur();
                } else {
                    if (this.element) {
                        setTimeout(() => {
                            this.element.focus();
                        }, 1);
                    }
                }
            }}
        >
            <Stars isFixed={true} value={this.props.average} />
            <span style={{
                marginLeft: '10px',
                fontSize: '16px',
                fontWeight: 'bold',
                color: 'black'
            }}>
                {this.props.average.toFixed(1)}{" out of 5"}
            </span>
            <div>{this.state.totalReviews}{" rating"}{this.state.totalReviews > 1 ? "s" : ""}</div>
            <div style={{
                width: '100%',
                height: '1px',
                borderTop: '1px solid #f4f4f4',
                marginTop: '5px'
            }}/>
            <div style={{
                marginTop: '10px',
                alignContent: 'baseline',
                lineHeight: '20px',
                height: '20px',
            }}>
                {"Rate this model "}
                <Stars
                    value={this.state.currentScore ? this.state.currentScore : (isReviewed ? this.props.userScore : 0)}
                    onReviewChange={(currentScore: number) => {
                        this.setState({
                            currentScore
                        });
                    }}
                />
                {
                    isReviewed && this.state.currentScore === 0 ? <span style={{
                        fontSize: '14px',
                        color: 'green',
                        marginLeft: '10px'
                    }}>
                        <Icon className="fas fa-check"/>
                    </span> : (this.state.loading ? <span style={{
                        fontSize: '14px',
                        marginLeft: '10px'
                    }}>
                        <Icon className="fas fa-spinner fa-spin" />
                    </span> : <Button
                        style={{
                            fontSize: '12px',
                            marginLeft: '10px',
                            marginTop: '-5px',
                            verticalAlign: 'middle'
                        }}
                        onClick={() => {this.onReviewSave()}}
                    >OK</Button>)
                }
            </div>
        </div>;
    }
}

export default RatingWindow;


// WEBPACK FOOTER //
// ./src/components/model/ModelInfo/RatingWindow.tsx